import { globalConfig } from '../config';

/**
 * 检测当前设备是移动端还是PC端
 * @returns 'mobile' | 'pc' 返回设备类型
 */
export function detectDeviceType(): 'mobile' | 'pc' {
  // 检查 navigator 是否存在（SSR环境如Next.js）
  if (typeof window === 'undefined' || !navigator) {
    return 'pc'; // 默认返回PC
  }

  const userAgent = navigator.userAgent.toLowerCase();
  const touchPoints = navigator.maxTouchPoints || 0;

  // 设备检测正则
  const mobileDevices = /android|webos|iphone|ipod|blackberry|windows phone|opera mini|iemobile|mobile/i;
  const tablets = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/i;

  // 触摸屏且小屏幕通常为移动设备
  const isTouchDevice = touchPoints > 0;
  const isSmallScreen = window.innerWidth < 1024;

  // 移动设备判定条件
  const isMobile =
    mobileDevices.test(userAgent) || (tablets.test(userAgent) && isSmallScreen) || (isTouchDevice && isSmallScreen);

  return isMobile ? 'mobile' : 'pc';
}

/**
 * 执行重定向到对应的端
 */
export function redirect2Mobile(): void {
  const deviceType = detectDeviceType();

  if (deviceType === 'mobile') {
    console.log('123');
    const newUrl = window.location.href.replace(globalConfig.pcUrl, globalConfig.h5Url);

    // 执行重定向（避免循环重定向）
    if (newUrl !== window.location.href) {
      window.location.href = newUrl;
    }
  }
}
